import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SiteHeader, SiteFooter } from "./components/Layout";
import AuthModal from "./components/AuthModal";
import { Toaster } from "./components/ui/sonner";

import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import Search from "./pages/Search";
import Results from "./pages/Results";
import History from "./pages/History";
import About from "./pages/About";
import ClinicalNotes from "./pages/ClinicalNotes";
import Goals from "./pages/Goals";
import GoalResults from "./pages/GoalResults";
import Plans from "./pages/Plans";
import Admin from "./pages/Admin";
import AdminUsers from "./pages/AdminUsers";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";

const Gate = ({ children }) => {
  const { loading } = useAuth();
  if (loading) return <div className="p-20 text-center text-[#52606D]">Loading…</div>;
  return children;
};

const Shell = () => (
  <div className="App min-h-screen flex flex-col">
    <SiteHeader />
    <main className="flex-1">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/clinical-notes" element={<ClinicalNotes />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/dashboard" element={<Gate><Dashboard /></Gate>} />
        <Route path="/search" element={<Gate><Search /></Gate>} />
        <Route path="/goals" element={<Gate><Goals /></Gate>} />
        <Route path="/goal-results/:id" element={<Gate><GoalResults /></Gate>} />
        <Route path="/results/:id" element={<Gate><Results /></Gate>} />
        <Route path="/history" element={<Gate><History /></Gate>} />
        <Route path="/admin" element={<Gate><Admin /></Gate>} />
        <Route path="/admin/users" element={<Gate><AdminUsers /></Gate>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </main>
    <SiteFooter />
    <AuthModal />
    <Toaster position="top-right" richColors />
  </div>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </AuthProvider>
  );
}
